import React from 'react'
import Navbar from '../inc/Navbar'
import Gallery from './Gallery'
import {Link} from "react-router-dom";

function Gallerypage() {
  return (
    <div>
        <Navbar/>
        <br/>
        <br/>
        <br/>
        <br/>
        <br/>
        <div className='colorgallery'>
                <div className="album py-1">
                    <div className="container mt-3">
                        <nav aria-label="breadcrumb">
                            <ol className="breadcrumb">
                                <li className="breadcrumb-item"><Link to="/" >Home</Link></li>
                                <li className="breadcrumb-item active" aria-current="page">Gallery</li>
                            </ol>
                        </nav>
                    </div>
                </div>
            </div>
        <Gallery/>
        <br/>
    </div>
  )
}

export default Gallerypage